var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"load"},[_c('img',{staticClass:"center-block",attrs:{"src":_vm.logo,"alt":"Cargando"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }